import { Grid, MenuItem, TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import { getTodayDateMoment, tableIcons } from "../../../Utilities/Utility";
import { tableOptionsComplaints } from "../../../Themes/LightTheme";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { BootstrapInput } from "../../../Utilities/Utility";
import { GetDetectedDDL, GetSeverityDDL } from "../../../Redux/APIs/api_Common";
import { useSelector } from "react-redux";
import {
  GetNonConformityDetails,
  PostDescriptionDetails,
  GetCurrencyMasterResult,
  GetDefectiveMaterialResult,
  GetCostTypesDDL,
  GetNccDropdown
} from "../../../Redux/APIs/api_Complaint";
import SnackbarCustom from "../../../Components/Snackbar/Snackbar";
import moment from "moment";

export default function NonConformityList(props) {
  const token = useSelector((state) => state.saveTokenReducer.token);
  const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const [open, setOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [tableData, setTableData] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [isCreditNoteSelected, setIsCreditNoteSelected] = useState(false);

  //azure ad
  const siteToken = useSelector((state) => state.saveBearerTokenReducer);
  const azureToken = useSelector((state) => state.saveTokenReducer);
  const UID = useSelector((state) => state.saveUserIdReducer);
  const handleSnackOpen = (text, type) => {
    setSnackMessage(text);
    setAlertType(type);
    setOpen(true);
  };
  const handleClose = (e) => {
    setOpen(false);
  };
  const [severity, setSeverity] = useState([]);
  async function SeverityDDL() {
    const response = await GetSeverityDDL(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    );
    if (response && response.length > 0) {
      setSeverity(response);
    } else {
      setSeverity([]);
    }
  }
  const [whereitisdetecteded, setwhereitisdetecteded] = useState([]);
  async function whereitisdetectedDDL() {
    const response = await GetDetectedDDL(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    );
    if (response && response.length > 0) {
      setwhereitisdetecteded(response);
    } else {
      setwhereitisdetecteded([]);
    }
  }
  const [disableRejectedQuantity, setDisableRejectedQuantity] = useState(true);
  const handleChangeNonConformity = (event, value) => {
    let elem = event.target.name;
    console.log("Child input changed:", event.target.value);
    props.setIsChanged(true); // 🔹 This updates parent's state
    switch (elem) {
      case "severity":
        if (
          props?.rowData?.status === "Draft" ||
          props?.rowData?.status === "Recall" ||
          props?.rowData?.status === "Sent back to Siemens"
        ) {
          props.setDraftInputs({
            ...props.draftInputs,
            severityId: value.props.value,
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: value.props.value,
          });
        }
        break;
      case "whereitisdetected":
        if (
          props?.rowData?.status === "Draft" ||
          props?.rowData?.status === "Recall" ||
          props?.rowData?.status === "Sent back to Siemens"
        ) {
          props.setDraftInputs({
            ...props.draftInputs,
            whereitisdetected: value.props.value,
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: value.props.value,
          });
        }
        break;
      case "issueReportedOn":
        if (
          props?.rowData?.status === "Draft" ||
          props?.rowData?.status === "Recall" ||
          props?.rowData?.status === "Sent back to Siemens"
        ) {
          props.setDraftInputs({
            ...props.draftInputs,
            [elem]: event.target.value,
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: event.target.value,
          });
        }
        break;
      case "defectiveParts":
        if (
          props?.rowData?.status === "Draft" ||
          props?.rowData?.status === "Recall" ||
          props?.rowData?.status === "Sent back to Siemens"
        ) {
          props.setDraftInputs({
            ...props.draftInputs,
            defectivePartsCount: parseInt(event.target.value),
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: event.target.value,
          });
        }
        break;
      case "estimatedDefectiveRate":
        if (
          props?.rowData?.status === "Draft" ||
          props?.rowData?.status === "Recall" ||
          props?.rowData?.status === "Sent back to Siemens"
        ) {
          props.setDraftInputs({
            ...props.draftInputs,
            [elem]: event.target.value,
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: event.target.value,
          });
        }
        break;
      case "potentialTotalQty":
        if (
          props?.rowData?.status === "Draft" ||
          props?.rowData?.status === "Recall" ||
          props?.rowData?.status === "Sent back to Siemens"
        ) {
          props.setDraftInputs({
            ...props.draftInputs,
            [elem]: parseInt(event.target.value),
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: event.target.value,
          });
        }
        break;
      case "isSortingrework":
        if (
          props?.rowData?.status === "Draft" ||
          props?.rowData?.status === "Recall" ||
          props?.rowData?.status === "Sent back to Siemens"
        ) {
          props.setDraftInputs({
            ...props.draftInputs,
            [elem]: value.props.value,
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: value.props.value,
          });
        }
        break;
      case "inspectedQty":
        if (
          props?.rowData?.status === "Draft" ||
          props?.rowData?.status === "Recall" ||
          props?.rowData?.status === "Sent back to Siemens"
        ) {
          props.setDraftInputs({
            ...props.draftInputs,
            inspectedQuantity: parseInt(event.target.value),
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: event.target.value,
          });
        }
        break;
      case "isRma":
        if (
          props?.rowData?.status === "Draft" ||
          props?.rowData?.status === "Recall" ||
          props?.rowData?.status === "Sent back to Siemens"
        ) {
          props.setDraftInputs({
            ...props.draftInputs,
            [elem]: value.props.value,
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: value.props.value,
          });
        }
        if (value.props.value === false) {
          setDisableRejectedQuantity(true);
        } else {
          setDisableRejectedQuantity(false);
        }
        break;
      case "rejectedRMAQty":
        if (
          props?.rowData?.status === "Draft" ||
          props?.rowData?.status === "Recall" ||
          props?.rowData?.status === "Sent back to Siemens"
        ) {
          props.setDraftInputs({
            ...props.draftInputs,
            rmarejectedQty: parseInt(event.target.value),
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: event.target.value,
          });
        }
        break;
      case "rejectedQty":
        if (
          props?.rowData) {
          props.setDraftInputs({
            ...props.draftInputs,
            [elem]: parseInt(event.target.value),
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: event.target.value,
          });
        }
        break;
      case "ncc":
        if (
          props?.rowData?.status === "Submitted" ||
          props?.rowData?.status === "Draft" ||
          props?.rowData?.status === "Recall" ||
          props?.rowData?.status === "Sent back to Siemens"
        ) {
          props.setDraftInputs({
            ...props.draftInputs,
            [elem]: event.target.value,
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: event.target.value,
          });
        }
      case "price":
        if (
          props?.rowData) {
          props.setDraftInputs({
            ...props.draftInputs,
            [elem]: event.target.value,
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: event.target.value,
          });
        }
      case "totalValue":
        if (
          props?.rowData?.status === "Submitted" ||
          props?.rowData?.status === "Draft" ||
          props?.rowData?.status === "Recall" ||
          props?.rowData?.status === "Sent back to Siemens"
        ) {
          props.setDraftInputs({
            ...props.draftInputs,
            [elem]: event.target.value,
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: event.target.value,
          });
        }
      case "postingReference":
        if (
          props?.rowData) {
          props.setDraftInputs({
            ...props.draftInputs,
            [elem]: event.target.value,
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: event.target.value,
          });
        }
      case "creditNoteValue":
        if (
          props?.rowData) {
          props.setDraftInputs({
            ...props.draftInputs,
            [elem]: event.target.value,
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: event.target.value,
          });
        }
      case "creditDebitRefNo":
        if (
          props?.rowData
         ) {
          props.setDraftInputs({
            ...props.draftInputs,
            [elem]: event.target.value,
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: event.target.value,
          });
        }
        break;
        case "IssueOrigin":
          if (
            props?.rowData
           ) {
            props.setDraftInputs({
              ...props.draftInputs,
              [elem]: event.target.value,
            });
          } else {
            props.setCreateComplaintInputs({
              ...props.createComplaintInputs,
              [elem]: event.target.value,
            });
          }
          break;
          case "TotalNcccost":
            if (
              props?.rowData
             ) {
              props.setDraftInputs({
                ...props.draftInputs,
                [elem]: event.target.value,
              });
            } else {
              props.setCreateComplaintInputs({
                ...props.createComplaintInputs,
                [elem]: event.target.value,
              });
            }
            break;
      default:
        break;
      
    }
    props.setIsChanged(true);
    //console.log('ischanges',props.setIsChanged(true));
  };
  const [disable, setDisable] = useState(true);
  function disableForm() {
    if (
      props?.rowData?.status === "Draft" ||
      props?.rowData === "" ||
      props?.rowData?.status === "Recall" ||
      props?.rowData?.status === "Sent back to Siemens"
    ) {
      if (
        props?.rowData?.status === "Sent back to Siemens" &&
        userDetails.roleId === 3
      ) {
        setDisable(true);
      } else {
        setDisable(false);
      }
    } else {
      setDisable(true);
    }
  }
  function getTableData() {
    setIsLoader(true);
    GetNonConformityDetails(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        if (props.rowData?.status) {
          var viewData = [
            {
              NonConformityId: 1,
              id: 1,
              isActive: true,
              nonConformityDescription: response[0].nonConformityDescription,
              complaintNumber: props.rowData?.name
                ? props?.complaintDetails.complaintNumber
                : props.rowData?.complaintNumber,
              DetailedDescription:
                props?.rowData?.detaildescription.length === 0
                  ? ""
                  : props?.rowData?.detaildescription[0].detailedDescription,
            },
            {
              NonConformityId: 2,
              id: 2,
              isActive: true,
              nonConformityDescription: response[1].nonConformityDescription,
              complaintNumber: props.rowData?.name
                ? props?.complaintDetails.complaintNumber
                : props.rowData?.complaintNumber,
              DetailedDescription:
                props?.rowData?.detaildescription.length === 0
                  ? ""
                  : props?.rowData?.detaildescription[1].detailedDescription,
            },
            {
              NonConformityId: 3,
              id: 3,
              isActive: true,
              nonConformityDescription: response[2].nonConformityDescription,
              complaintNumber: props.rowData?.name
                ? props?.complaintDetails.complaintNumber
                : props.rowData?.complaintNumber,
              DetailedDescription:
                props?.rowData?.detaildescription.length === 0
                  ? ""
                  : props?.rowData?.detaildescription[2].detailedDescription,
            },
            {
              NonConformityId: 4,
              id: 4,
              isActive: true,
              nonConformityDescription: response[3].nonConformityDescription,
              complaintNumber: props.rowData?.name
                ? props?.complaintDetails.complaintNumber
                : props.rowData?.complaintNumber,
              DetailedDescription:
                props?.rowData?.detaildescription.length === 0
                  ? ""
                  : props?.rowData?.detaildescription[3].detailedDescription,
            },
            {
              NonConformityId: 6,
              id: 6,
              isActive: true,
              nonConformityDescription: response[4].nonConformityDescription,
              complaintNumber: props.rowData?.name
                ? props?.complaintDetails.complaintNumber
                : props.rowData?.complaintNumber,
              DetailedDescription:
                props?.rowData?.detaildescription.length === 0
                  ? ""
                  : props?.rowData?.detaildescription[4].detailedDescription,
            },
          ];
          setTableData(viewData);
        } else {
          var newData = response?.map((item) => {
            item.DetailedDescription = "";
            item.complaintNumber = props?.complaintDetails.complaintNumber;
            item.NonConformityId = item.id;
            return item;
          });
          setTableData(newData);
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            detailDescription: newData,
          });
        }
        setIsLoader(false);
      })
      .catch((error) => {
        handleSnackOpen("Error : " + error, "error");
        setIsLoader(false);
      });
  }
  const InspectionValues = [
    {
      id: true,
      name: "Yes",
    },
    {
      id: false,
      name: "No",
    },
  ];
  const RejectionValues = [
    {
      id: true,
      name: "Yes",
    },
    {
      id: false,
      name: "No",
    },
  ];
  function validateNonConformity(value) {
    return !value.DetailedDescription
      ? { isValid: false, helperText: "*Required" }
      : { isValid: true, helperText: "" };
  }
  var columns = [
    {
      title: "Questions",
      field: "nonConformityDescription",
      editable: "never",
    },
    {
      title: "Description",
      field: "DetailedDescription",
      editable: props?.rowData
        ? props.rowData.status === "Draft" ||
          props?.rowData?.status === "Recall" ||
          props?.rowData?.status === "Sent back to Siemens"
          ? "always"
          : "never"
        : "always",
      editComponent: ({ value, onChange }) => (
        <TextField
          fullWidth
          onChange={(e) => onChange(e.target.value)}
          value={value}
          error={!value}
          helperText={!value ? "required" : ""}
          multiline
        />
      ),
      validate: (rowData) => validateNonConformity(rowData),
    },
    {
      title: "ComplaintNumber",
      field: "complaintNumber",
      hidden: true,
    },
  ];

  useEffect(() => {
    if (props) {
      disableForm();
      if (props.rowData.isRma === true) {
        setDisableRejectedQuantity(false);
      }
      //console.log('ischanges',props.setIsChanged(true));
    }

    SeverityDDL();
    whereitisdetectedDDL();
  }, []);
  useEffect(() => {
    if(tableData.length == 0){
      getTableData();
    }
   
    getCurrencyMaster();
    getDefectiveMaterialDropdown();
    getTypeOfCostDropdown();
    getNccDropdown();
    //console.log('props ischananged',props.setIsChanged(true));
  }, [props?.complaintDetails?.complaintNumber]);

  const [currencyDropdown, setCurrencyDropdown] = useState([]);
  function getCurrencyMaster() {
    GetCurrencyMasterResult(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setCurrencyDropdown(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const [creditNoteCurrencyName, setCreditNoteCurrencyName] = useState([]);
  const handleCreditNoteCurrency = (e) => {
    setCreditNoteCurrencyName(e.target.value);
    if (
      props?.rowData
     
    ) {
      props.setDraftInputs({
        ...props.draftInputs,
        CreditNoteCurrencyId: e.target.value,
      });
    } else {
      props.setCreateComplaintInputs({
        ...props.createComplaintInputs,
        CreditNoteCurrencyId: e.target.value,
      });
    }
    props.setIsChanged(true);
  };

  const [defectivePartCurrencyName, setdefectivePartCurrencyName] = useState(
    []
  );
  const handleDefectivePartCurrency = (e) => {
    setdefectivePartCurrencyName(e.target.value);
    if (
      props?.rowData) {
      props.setDraftInputs({
        ...props.draftInputs,
        DefectivePartCurrencyId: e.target.value,
      });
    } else {
      props.setCreateComplaintInputs({
        ...props.createComplaintInputs,
        DefectivePartCurrencyId: e.target.value,
      });
    }
    props.setIsChanged(true);
  };

  const [defectiveMaterialName, setDefectiveMaterialName] = useState([]);
  const handleDefectiveMaterial = (e) => {

    setdefectivePartCurrencyName(e.target.value);
    if(e.target.value == 4){
      setIsCreditNoteSelected(true);
    }else{
      setIsCreditNoteSelected(false);
    }
    if (
      props?.rowData) {
      props.setDraftInputs({
        ...props.draftInputs,
        DefectiveMaterialId: e.target.value,
      });
    } else {
      props.setCreateComplaintInputs({
        ...props.createComplaintInputs,
        DefectiveMaterialId: e.target.value,
      });
    }
    props.setIsChanged(true);
  };

  const [typeOfCostName, setTypeOfCostName] = useState([]);
  const handleTypeOfCost = (e) => {
    setTypeOfCostName(e.target.value);
    if (
      props?.rowData
     
    ) {
      props.setDraftInputs({
        ...props.draftInputs,
        CostTypeId: e.target.value,
      });
    } else {
      props.setCreateComplaintInputs({
        ...props.createComplaintInputs,
        CostTypeId: e.target.value,
      });
    }
  };

  const [nccName, setNCCName] = useState([]);
  const handleNcc = (e) => {
    setNCCName(e.target.value);
    if (
      props?.rowData
     
    ) {
      props.setDraftInputs({
        ...props.draftInputs,
        Nccid: e.target.value,
      });
    } else {
      props.setCreateComplaintInputs({
        ...props.createComplaintInputs,
        Nccid: e.target.value,
      });
    }
    props.setIsChanged(true);
  };

  const [defectiveMaterialDropdown, setDefectiveMaterialDropdown] = useState(
    []
  );
  function getDefectiveMaterialDropdown() {
    GetDefectiveMaterialResult(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setDefectiveMaterialDropdown(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const [typeOfCost,setTypeOfCost] = useState([])
  function getTypeOfCostDropdown() {
    GetCostTypesDDL(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setTypeOfCost(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const [ncc,setNcc] = useState([])
  function getNccDropdown() {
    GetNccDropdown(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setNcc(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }




  // Extract status
const status = props?.rowData?.status;
 
//  Get rejectedQty
const rejectedQty =
  status 
    ? props.draftInputs.rejectedQty
    : props.rowData?.rejectedQty || props.createComplaintInputs.rejectedQty;
 
//  Get price
const price =
  status
    ? props.draftInputs.price
    : props.rowData?.price || props.createComplaintInputs.price;
 
//  Calculate Total Value
const totalValue = Number(rejectedQty || 0) * Number(price || 0);

  return (
    <>
      <Grid container className="complaintsHomePage">
        <Grid item xs={12}>
          <h3 className="title-heading">Description of Non Conformity **</h3>
        </Grid>
        <Grid item xs={12} className="matTable">
          <div className="Table-margin">
            <MaterialTable
              columns={columns}
              data={tableData}
              icons={tableIcons}
              isLoading={isLoader}
              options={tableOptionsComplaints}
              editable={{
                onRowUpdate: (newData, oldData) =>
                  new Promise((resolve, reject) => {
                    setTimeout(() => {
                      const dataUpdate = [...tableData];
                      const index = oldData.tableData.id;
                      dataUpdate[index] = newData;
                      setTableData([...dataUpdate]);
                      if (
                        props?.rowData?.status === "Draft" ||
                        props?.rowData?.status === "Recall" ||
                        props?.rowData?.status === "Sent back to Siemens"
                      ) {
                        props.setDraftInputs({
                          ...props.draftInputs,
                          detaildescription: dataUpdate,
                        });
                      } else {
                        props.setCreateComplaintInputs({
                          ...props.createComplaintInputs,
                          detailDescription: dataUpdate,
                        });
                      }

                      resolve();
                    }, 1000);
                  }),
              }}
            />
          </div>
        </Grid>
      </Grid>
      <Grid className="view-block">
        <div className="inner-vb">
          <Grid container spacing={2}>

          <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="bootstrap-input">
                  Rejected Quantity
                </InputLabel>
                <BootstrapInput
                  type="number"
                  id="bootstrap-input"
                  name="rejectedQty"
                  inputProps={{ min: 0 }}
                  value={
                    props.rowData
                      ? props.draftInputs.rejectedQty
                      : props.createComplaintInputs.rejectedQty
                  }
                  // value={
                  //   props.rowData
                  //     ? props?.rowData?.status === "Submitted" ||
                  //       props.rowData.status === "Draft" ||
                  //       props.rowData.status === "Recall" ||
                  //       props?.rowData?.status === "Sent back to Siemens"
                  //       ? props.draftInputs.rejectedQty
                  //       : props.rowData.rejectedQty
                  //     : props.createComplaintInputs.rejectedQty
                  // }
                  // disabled={disable}
                  onChange={handleChangeNonConformity}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl
                error={
                  props.rowData
                    ? props.rowData.status === "Draft" ||
                      props.rowData.status === "Recall"
                      ? !props.draftInputs.severityId
                      : !props.rowData.severityId
                    : !props.createComplaintInputs.severity
                }
                fullWidth
              >
                <InputLabel shrink htmlFor="bootstrap-input">
                  {" "}
                  Severity**
                </InputLabel>
                <Select
                  labelId="severity"
                  id="severity"
                  name="severity"
                  value={
                    props.rowData
                      ?props?.rowData?.status === "Submitted" ||
                       props.rowData.status === "Draft" ||
                        props.rowData.status === "Recall" ||
                        props?.rowData?.status === "Sent back to Siemens"
                        ? props.draftInputs.severityId
                        : props.rowData.severityId
                      : props.createComplaintInputs.severity
                  }
                  //disabled={disable}
                  onChange={handleChangeNonConformity}
                  input={<BootstrapInput />}
                >
                  {severity?.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl
                error={
                  props.rowData
                    ? props.rowData.status === "Draft" ||
                      props.rowData.status === "Recall" ||
                      props?.rowData?.status === "Sent back to Siemens"
                      ? !props.draftInputs.issueReportedOn
                      : !props.rowData.issueReportedOn
                    : !props.createComplaintInputs.issueReportedOn
                }
                fullWidth
              >
                <InputLabel shrink htmlFor="bootstrap-input">
                  Issue Reported Date **
                </InputLabel>
                <BootstrapInput
                  type="date"
                  id="bootstrap-input"
                  name="issueReportedOn"
                  inputProps={{ max: getTodayDateMoment() }}
                  value={
                    props.rowData
                      ? props.rowData.status === "Draft" ||
                        props.rowData.status === "Recall" ||
                        props?.rowData?.status === "Sent back to Siemens"
                        ? moment(props.draftInputs.issueReportedOn).format(
                            "YYYY-MM-DD"
                          )
                        : moment(props.rowData.issueReportedOn).format(
                            "YYYY-MM-DD"
                          )
                      : props.createComplaintInputs.issueReportedOn
                  }
                  disabled={disable}
                  onChange={handleChangeNonConformity}
                />
              </FormControl>
            </Grid>

            

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="bootstrap-input">
                  NCC
                </InputLabel>
                <Select
                  labelId="NCC"
                  id="ncc"
                  name="ncc"
                  onChange={handleNcc}
                  value={
                    props.rowData
                      ? props.draftInputs.Nccid
                      : props.createComplaintInputs.Nccid
                  }
                  // value={
                  //   props.rowData
                  //     ? props.rowData.status === "Draft" ||
                  //       props.rowData.status === "Recall" ||
                  //       props?.rowData?.status === "Sent back to Siemens" ||
                  //       props?.rowData?.status === "Submitted"
                  //       ? props.draftInputs.DefectiveMaterialId
                  //       : props.rowData.DefectiveMaterialId
                  //     : props.createComplaintInputs.DefectiveMaterialId
                  // }
                  // disabled={userDetails.roleId == 3 || userDetails.roleId == 4 || userDetails.roleId == 5 || userDetails.roleId == 7 || userDetails.roleId == 8 || userDetails.roleId == 9 || userDetails.roleId == 10}
                  input={<BootstrapInput />}
                >
                  {ncc?.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
                {/* <BootstrapInput
                  type="text"
                  id="bootstrap-input"
                  name="ncc"
                  value={
                    props.rowData
                      ? 
                      props.rowData.status === "Draft" ||
                        props.rowData.status === "Recall" ||
                        props?.rowData?.status === "Sent back to Siemens"
                        ? props.draftInputs.ncc
                        : props.rowData.ncc
                      : props.createComplaintInputs.ncc
                  }
                  disabled={disable}
                  onChange={handleChangeNonConformity}
                /> */}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="bootstrap-input">
                  Price
                </InputLabel>
                <BootstrapInput
                  type="text"
                  id="bootstrap-input"
                  name="price"
                  value={
                    props.rowData
                      ? props.draftInputs.price
                      : props.createComplaintInputs.price
                  }
                 
                  // disabled={disable}
                  onChange={handleChangeNonConformity}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="bootstrap-input">
                  Posting Reference
                </InputLabel>
                <BootstrapInput
                  type="text"
                  id="bootstrap-input"
                  name="postingReference"
                  value={
                    props.rowData
                      ? props.draftInputs.postingReference
                      : props.createComplaintInputs.postingReference
                  }
                  // value={
                  //   props.rowData
                  //     ? props?.rowData?.status === "Submitted" ||
                  //     props.rowData.status === "Draft" ||
                  //       props.rowData.status === "Recall" ||
                  //       props?.rowData?.status === "Sent back to Siemens"
                  //       ? props.draftInputs.postingReference
                  //       : props.rowData.postingReference
                  //     : props.createComplaintInputs.postingReference
                  // }
                  // disabled={disable}
                  onChange={handleChangeNonConformity}
                />
              </FormControl>
            </Grid>
           

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="bootstrap-input">
                  Method of Replacing Defective material **
                </InputLabel>
                <Select
                  labelId="Method of Replacing Defective material  "
                  id="defectiveMaterialName"
                  name="defectiveMaterialName"
                  onChange={handleDefectiveMaterial}
                  value={
                    props.rowData
                      ? props.draftInputs.DefectiveMaterialId
                      : props.createComplaintInputs.DefectiveMaterialId
                  }
                  // value={
                  //   props.rowData
                  //     ? props.rowData.status === "Draft" ||
                  //       props.rowData.status === "Recall" ||
                  //       props?.rowData?.status === "Sent back to Siemens" ||
                  //       props?.rowData?.status === "Submitted"
                  //       ? props.draftInputs.DefectiveMaterialId
                  //       : props.rowData.DefectiveMaterialId
                  //     : props.createComplaintInputs.DefectiveMaterialId
                  // }
                  // disabled={userDetails.roleId == 3 || userDetails.roleId == 4 || userDetails.roleId == 5 || userDetails.roleId == 7 || userDetails.roleId == 8 || userDetails.roleId == 9 || userDetails.roleId == 10}
                  input={<BootstrapInput />}
                >
                  {defectiveMaterialDropdown?.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="bootstrap-input">
                  Defective Part Currency
                </InputLabel>
                <Select
                  labelId="Defective Part Currency"
                  id="defectivePartCurrencyName"
                  name="defectivePartCurrencyName"
                  onChange={handleDefectivePartCurrency}
                  // value={sqmResp}
                  value={
                    props.rowData
                      ? props.draftInputs.DefectivePartCurrencyId
                      : props.createComplaintInputs.DefectivePartCurrencyId
                  }
                  // value={
                  //   props.rowData
                  //     ? props.rowData.status === "Draft" ||
                  //       props.rowData.status === "Recall" ||
                  //       props?.rowData?.status === "Sent back to Siemens" ||
                  //       props?.rowData?.status === "Submitted"
                  //       ? props.draftInputs.DefectivePartCurrencyId
                  //       : props.rowData.DefectivePartCurrencyId
                  //     : props.createComplaintInputs.DefectivePartCurrencyId
                  // }
                  // disabled={userDetails.roleId == 3 || userDetails.roleId == 4 || userDetails.roleId == 5 || userDetails.roleId == 7 || userDetails.roleId == 8 || userDetails.roleId == 9 || userDetails.roleId == 10}
                  input={<BootstrapInput />}
                >
                  {currencyDropdown?.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.code}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

           

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="bootstrap-input">
                  Total Value
                </InputLabel>
                <BootstrapInput
                  type="text"
                  id="bootstrap-input"
                  name="totalValue"
                  value={totalValue}
                  disabled
                 // onChange={handleChangeNonConformity}
                />
              </FormControl>
            </Grid>
            {defectiveMaterialDropdown?.find(item => item.id === (props.rowData ? props.draftInputs.DefectiveMaterialId : props.createComplaintInputs.DefectiveMaterialId))?.name === "Credit Note" && (
              <>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="bootstrap-input">
                  Credit Note Value
                </InputLabel>
                <BootstrapInput
                  type="text"
                  id="bootstrap-input"
                  name="creditNoteValue"
                  value={
                    props.rowData
                      ? props.draftInputs.creditNoteValue
                      : props.createComplaintInputs.creditNoteValue
                  }
                 
                  // disabled={disable}
                  onChange={handleChangeNonConformity}
                />
              </FormControl>
            </Grid>
            </>
            )}
            
            {defectiveMaterialDropdown?.find(item => item.id === (props.rowData ? props.draftInputs.DefectiveMaterialId : props.createComplaintInputs.DefectiveMaterialId))?.name === "Credit Note" && (
              <>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="bootstrap-input">
                  Credit Note Ref. No.
                </InputLabel>
                <BootstrapInput
                  type="text"
                  id="bootstrap-input"
                  name="creditDebitRefNo"
                  value={
                    props.rowData
                      ? props.draftInputs.creditDebitRefNo
                      : props.createComplaintInputs.creditDebitRefNo
                  }
                 
                  // disabled={disable}
                  onChange={handleChangeNonConformity}
                />
              </FormControl>
            </Grid>
            </>
            )}
            {defectiveMaterialDropdown?.find(item => item.id === (props.rowData ? props.draftInputs.DefectiveMaterialId : props.createComplaintInputs.DefectiveMaterialId))?.name === "Credit Note" && (
              <>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="bootstrap-input">
                  Credit Note Currency
                </InputLabel>
                <Select
                  labelId="Credit Note Currency"
                  id="creditNoteCurrencyName"
                  name="creditNoteCurrencyName"
                  onChange={handleCreditNoteCurrency}
                  // value={sqmResp}
                  value={
                    props.rowData
                      ? props.draftInputs.CreditNoteCurrencyId
                      : props.createComplaintInputs.CreditNoteCurrencyId
                  }
                  // value={
                  //   props.rowData
                  //     ? props.rowData.status === "Draft" ||
                  //       props.rowData.status === "Recall" ||
                  //       props?.rowData?.status === "Sent back to Siemens" ||
                  //       props?.rowData?.status === "Submitted"
                  //       ? props.draftInputs.CreditNoteCurrencyId
                  //       : props.rowData.CreditNoteCurrencyId
                  //     : props.createComplaintInputs.CreditNoteCurrencyId
                  // }
                  // disabled={userDetails.roleId == 3 || userDetails.roleId == 4 || userDetails.roleId == 5 || userDetails.roleId == 7 || userDetails.roleId == 8 || userDetails.roleId == 9 || userDetails.roleId == 10}
                  input={<BootstrapInput />}
                >
                  {currencyDropdown?.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.code}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            </>
            )}

            {/* for pundicherry location */}
            {userDetails.locationName == "Puducherry" && (
              <>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="bootstrap-input">
                    Origin of the reported issue
                </InputLabel>
                <BootstrapInput
                  type="text"
                  id="bootstrap-input"
                  name="IssueOrigin"
                  value={
                    props.rowData
                      ? props.draftInputs.IssueOrigin
                      : props.createComplaintInputs.IssueOrigin
                  }
                 
                  // disabled={disable}
                  onChange={handleChangeNonConformity}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="bootstrap-input">
                Type of cost
                </InputLabel>
                <Select
                  labelId="Type of cost"
                  id="CostTypeId"
                  name="CostTypeId"
                  onChange={handleTypeOfCost}
                  // value={sqmResp}
                  value={
                    props.rowData
                      ? props.draftInputs.CostTypeId
                      : props.createComplaintInputs.CostTypeId
                  }
                  
                  input={<BootstrapInput />}
                >
                  {typeOfCost?.map((item) => (
                    <MenuItem key={item.costTypeId} value={item.costTypeId}>
                      {item.costType}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="bootstrap-input">
                Total NCC Cost/Value
                </InputLabel>
                <BootstrapInput
                  type="number"
                  step="0.01"
                  min="0"
                  id="bootstrap-input"
                  name="TotalNcccost"
                  value={
                    props.rowData
                      ? props.draftInputs.TotalNcccost
                      : props.createComplaintInputs.TotalNcccost
                  }
                 
                  // disabled={disable}
                  onChange={handleChangeNonConformity}
                />
              </FormControl>
            </Grid>
            </>
            )}


            {/* for pundicherry location */}

           
          </Grid>
        </div>

        <Grid container spacing={2} md={12}>
          <Grid className="align-ctr" item xs={12} sm={3} md={4}>
            <span>Where has it been detected?</span>
          </Grid>
          <Grid item xs={12} sm={3} md={2}>
            <TextField
              className="mt-1"
              select
              fullWidth
              value={
                props.rowData
                  ? props.rowData.status === "Draft" ||
                    props.rowData.status === "Recall" ||
                    props?.rowData?.status === "Sent back to Siemens"
                    ? props.draftInputs.whereitisdetected
                    : props.rowData.whereitisdetected
                  : props.createComplaintInputs.whereitisdetected
              }
              error={
                props.rowData
                  ? props.rowData.status === "Draft" ||
                    props.rowData.status === "Recall" ||
                    props?.rowData?.status === "Sent back to Siemens"
                    ? !props.draftInputs.whereitisdetected
                    : !props.rowData.whereitisdetected
                  : !props.createComplaintInputs.whereitisdetected
              }
              helperText={
                props.rowData
                  ? props.rowData.status === "Draft" ||
                    props.rowData.status === "Recall" ||
                    props?.rowData?.status === "Sent back to Siemens"
                    ? !props.draftInputs.whereitisdetected
                    : !props.rowData.whereitisdetected
                  : !props.createComplaintInputs.whereitisdetected
                  ? "** Required"
                  : ""
              }
              disabled={disable}
              onChange={handleChangeNonConformity}
              name="whereitisdetected"
              type="text"
              id="whereitisdetected"
            >
              {whereitisdetecteded?.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid className="align-ctr" item xs={12} sm={3} md={4}>
            <span>How many defective parts ? Actually observed</span>
          </Grid>
          <Grid item xs={12} sm={3} md={2}>
            <TextField
              className="mt-1"
              name="defectiveParts"
              fullWidth
              type="number"
              inputProps={{ min: 0 }}
              disabled={disable}
              onChange={handleChangeNonConformity}
              value={
                props.rowData
                  ? props.rowData.status === "Draft" ||
                    props.rowData.status === "Recall" ||
                    props?.rowData?.status === "Sent back to Siemens"
                    ? props.draftInputs.defectivePartsCount
                    : props.rowData.defectivePartsCount
                  : props.createComplaintInputs.defectiveParts
              }
              whereitisdetected
              id="rejectQuantity"
            />
          </Grid>
          <Grid className="align-ctr" item xs={12} sm={3} md={4}>
            <span>Inspected Estimated Defective Rate in (% / PPM)</span>
          </Grid>
          <Grid item xs={12} sm={3} md={2}>
            <TextField
              className="mt-1"
              name="estimatedDefectiveRate"
              type="text"
              fullWidth
              disabled={disable}
              onChange={handleChangeNonConformity}
              value={
                props.rowData
                  ? props.rowData.status === "Draft" ||
                    props.rowData.status === "Recall" ||
                    props?.rowData?.status === "Sent back to Siemens"
                    ? props.draftInputs.estimatedDefectiveRate
                    : props.rowData.estimatedDefectiveRate
                  : props.createComplaintInputs.estimatedDefectiveRate
              }
              id="rejectQuantity"
            />
          </Grid>
          <Grid className="align-ctr" item xs={12} sm={3} md={4}>
            <span>Potentially total concerned Quantity (stock /transit)</span>
          </Grid>
          <Grid item xs={12} sm={3} md={2}>
            <TextField
              className="mt-1"
              name="potentialTotalQty"
              type="number"
              inputProps={{ min: 0 }}
              fullWidth
              disabled={disable}
              onChange={handleChangeNonConformity}
              value={
                props.rowData
                  ? props.rowData.status === "Draft" ||
                    props.rowData.status === "Recall" ||
                    props?.rowData?.status === "Sent back to Siemens"
                    ? props.draftInputs.potentialTotalQty
                    : props.rowData.potentialTotalQty
                  : props.createComplaintInputs.potentialTotalQty
              }
              id="rejectQuantity"
            />
          </Grid>
          <Grid className="align-ctr" item xs={12} sm={3} md={4}>
            <span>Sorting /rework / inspection required for stock </span>
          </Grid>
          <Grid item xs={12} sm={3} md={2}>
            <TextField
              className="mt-1"
              value={
                props.rowData
                  ? props.rowData.status === "Draft" ||
                    props.rowData.status === "Recall" ||
                    props?.rowData?.status === "Sent back to Siemens"
                    ? props.draftInputs.isSortingrework
                    : props.rowData.isSortingrework
                  : props.createComplaintInputs.isSortingrework
              }
              disabled={disable}
              fullWidth
              select
              name="isSortingrework"
              type="text"
              onChange={handleChangeNonConformity}
              id="rejectQuantity"
            >
              {InspectionValues?.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid className="align-ctr" item xs={12} sm={3} md={4}>
            <span>Inspected Quantity</span>
          </Grid>
          <Grid item xs={12} sm={3} md={2}>
            <TextField
              className="mt-1"
              fullWidth
              name="inspectedQty"
              value={
                props.rowData
                  ? props.rowData.status === "Draft" ||
                    props.rowData.status === "Recall" ||
                    props?.rowData?.status === "Sent back to Siemens"
                    ? props.draftInputs.inspectedQuantity
                    : props.rowData.inspectedQuantity
                  : props.createComplaintInputs.inspectedQty
              }
              disabled={disable}
              onChange={handleChangeNonConformity}
              type="number"
              inputProps={{ min: 0 }}
              id="rejectQuantity"
            />
          </Grid>
          <Grid className="align-ctr" item xs={12} sm={3} md={4}>
            <span>RMA For Rejected</span>
          </Grid>
          <Grid item xs={12} sm={3} md={2}>
            <TextField
              className="mt-1"
              value={
                props.rowData
                  ? props.rowData.status === "Draft" ||
                    props.rowData.status === "Recall" ||
                    props?.rowData?.status === "Sent back to Siemens"
                    ? props.draftInputs.isRma
                    : props.rowData.isRma
                  : props.createComplaintInputs.isRma
              }
              disabled={disable || isCreditNoteSelected}
              onChange={handleChangeNonConformity}
              fullWidth
              select
              name="isRma"
              type="text"
              id="rejectQuantity"
            >
              {RejectionValues?.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid className="align-ctr" item xs={12} sm={3} md={4}>
            <span>RMA Rejected Quantity </span>
          </Grid>
          <Grid item xs={12} sm={3} md={2}>
            <TextField
              className="mt-1"
              fullWidth
              onChange={handleChangeNonConformity}
              value={
                props.rowData
                  ? props.rowData.status === "Draft" ||
                    props.rowData.status === "Recall" ||
                    props?.rowData?.status === "Sent back to Siemens"
                    ? props.draftInputs.rmarejectedQty
                    : props.rowData.rmarejectedQty
                  : props.createComplaintInputs.rejectedRMAQty
              }
              disabled={disable || disableRejectedQuantity}
              name="rejectedRMAQty"
              type="number"
              inputProps={{ min: 0 }}
              id="rejectedRMAQty"
            />
            <>
              <SnackbarCustom
                open={open}
                message={snackMessage}
                alertType={alertType}
                handleClose={handleClose}
              />
            </>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
